<template>
<section id="faq" class="vpn-section faq-sec">
  <div class="vpn-section__inner">
    <h2 class="vpn-section__title">{{ title }}</h2>
    <div class="faq-sec__list">
      <div
        v-for="(item, index) in faqItems"
        :key="item.q"
        class="faq-sec__item"
        :class="{ 'is-open': activeIndex === index }"
      >
        <button type="button" class="faq-sec__q" @click="toggle(index)">
          <span>{{ item.q }}</span>
          <span class="faq-sec__icon" aria-hidden="true">{{ activeIndex === index ? '−' : '+' }}</span>
        </button>
        <div v-show="activeIndex === index" class="faq-sec__a">
          <p>{{ item.a }}</p>
        </div>
      </div>
    </div>
  </div>
</section>
</template>

<script>
export default {
  name: 'FaqSection',
  props: {
    title: {
      type: String,
      default: 'FAQ',
    },
    items: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      // 文档要求：第一个默认展开
      activeIndex: 0,
      faqs: [
        {
          q: 'Does a VPN slow down my internet?',
          a: 'A VPN may slightly reduce your connection speed because your traffic is routed through a secure server. In most cases, the difference is small and you can still browse, stream, and use apps normally.',
        },
        {
          q: 'Is SecureVPN safe to use?',
          a: 'SecureVPN helps protect your online privacy by encrypting your connection and hiding your IP address. Always download the app from trusted sources and check the privacy policy before use.',
        },
        {
          q: 'Is it legal to use a VPN?',
          a: 'In most countries, using a VPN is legal and commonly used for online privacy and security. Users should follow the laws and regulations that apply in their location.',
        },
        {
          q: 'How long can I keep SecureVPN connected?',
          a: 'You can keep SecureVPN connected while you need a protected internet connection. Connection limits may vary depending on the app version and service conditions.',
        },
        {
          q: 'How to use Secure VPN?',
          a: 'Install Secure VPN, open the app, choose a server if available, and tap the connect button. Once connected, your internet traffic will be routed through the VPN.',
        },
        {
          q: 'Does using Secure VPN affect battery life?',
          a: "Secure VPN may use a small amount of additional battery because it keeps your connection active. In most cases, the impact is minimal and shouldn't noticeably affect normal daily use.",
        },
      ],
    }
  },
  computed: {
    faqItems() {
      return Array.isArray(this.items) && this.items.length ? this.items : this.faqs
    },
  },
  methods: {
    toggle(index) {
      this.activeIndex = this.activeIndex === index ? null : index
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/css/vpn-sections.scss';

.faq-sec {
  .vpn-section__title {
    text-align: left;
    max-width: none;
    margin-left: 0;
    margin-right: 0;
  }
}

.faq-sec__list {
  max-width: none;
  margin: 0;
  width: 100%;
  display: grid;
  gap: 12px;
}

.faq-sec__item {
  background: #fff;
  border: 1px solid var(--vpn-line, #e8e4f8);
  border-radius: 14px;
  overflow: hidden;
}

.faq-sec__q {
  width: 100%;
  border: 0;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 18px 20px;
  text-align: left;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  color: var(--vpn-ink, #1f2430);
}

.faq-sec__icon {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: rgba(109, 74, 255, 0.1);
  color: var(--vpn-brand, #6d4aff);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  flex-shrink: 0;
}

.faq-sec__a {
  padding: 0 20px 18px;

  p {
    margin: 0;
    color: var(--vpn-ink-muted, #5b6475);
    font-size: 15px;
    line-height: 1.6;
  }
}

.faq-sec__item.is-open {
  border-color: rgba(109, 74, 255, 0.28);
  box-shadow: 0 8px 22px rgba(109, 74, 255, 0.08);
}

@media (max-width: 768px) {
  .faq-sec__q {
    padding: 14px 14px;
    font-size: 14.5px;
    gap: 12px;
  }

  .faq-sec__icon {
    width: 26px;
    height: 26px;
    font-size: 16px;
  }

  .faq-sec__a {
    padding: 0 14px 14px;

    p {
      font-size: 14px;
    }
  }
}
</style>
